

    require('./heatmap/HeatmapSeries');
    require('./heatmap/HeatmapView');



//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/chart/heatmap.js
// module id = 833
// module chunks = 158